<div class="chat-aviso" *ngIf="visivel">
  <div class="chat-aviso-trigger" (click)="toggleLista()" nbTooltip="Chat" nbTooltipPlacement="bottom">
    <div class="chat-aviso-icon">
      <nb-icon icon="message-circle-outline"></nb-icon>
      <span class="badge" *ngIf="naoLidos > 0">{{ naoLidos }}</span>
    </div>
  </div>

  <div class="chat-aviso-lista" *ngIf="mostrarLista" (click)="$event.stopPropagation()">
    <div class="chat-aviso-header">
      <h4>Chat</h4>
      <div class="header-actions">
        <button class="btn-atualizar"
                type="button"
                (click)="atualizar($event)"
                [disabled]="atualizando"
                nbTooltip="Atualizar"
                nbTooltipPlacement="bottom">
          <nb-icon icon="refresh-outline" [class.spin]="atualizando"></nb-icon>
          Atualizar
        </button>
      </div>
    </div>

    <div class="chat-aviso-content">
      <div *ngIf="avisos.length === 0" class="sem-avisos">
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        <p>Nenhuma mensagem nova.</p>
      </div>

      <div *ngIf="avisos.length > 0" class="lista-avisos">
        <div *ngFor="let aviso of avisos"
             class="aviso-item"
             [class.nao-lida]="!aviso.lida"
             (click)="marcarAoClicar(aviso)">
          <div class="aviso-conteudo">
            <div class="aviso-header">
              <h5 class="aviso-titulo">{{ aviso.nomeCliente }}</h5>
              <div class="aviso-header-meta">
                <span class="aviso-tempo">{{ aviso.dataEnvio | date:'dd/MM HH:mm' }}</span>
                <button class="btn-fechar-aviso"
                        type="button"
                        nbTooltip="Fechar"
                        nbTooltipPlacement="top"
                        (click)="fecharAviso($event, aviso)">
                  <nb-icon icon="close-outline"></nb-icon>
                </button>
              </div>
            </div>

            <div class="aviso-mensagem">
              <p class="mensagem-principal">
                Cliente:
                <span class="link-cliente"
                      role="link"
                      tabindex="0"
                      [class.link-cliente--carregando]="clienteLinkCarregandoId === aviso.id"
                      (click)="abrirNestaAba($event, aviso)"
                      (keydown.enter)="abrirNestaAba($event, aviso)">
                  {{ aviso.nomeCliente }}
                </span>
              </p>
            </div>

            <div class="aviso-detalhes">
              <div class="detalhe-item">
                <nb-icon icon="user-outline" class="detalhe-icon"></nb-icon>
                <span class="detalhe-label">{{ aviso.paraTimeOperacional ? 'Enviado por' : 'Operacional' }}:</span>
                <span class="detalhe-valor">
                  {{ aviso.remetenteNome }}<span *ngIf="descricaoTipo(aviso.tipoUsuarioEnvio)"> · {{ descricaoTipo(aviso.tipoUsuarioEnvio) }}</span>
                </span>
              </div>
            </div>

            <div class="aviso-acoes">
              <button class="btn-acao" type="button" (click)="abrirNestaAba($event, aviso)" [disabled]="clienteLinkCarregandoId === aviso.id">
                <nb-icon icon="external-link-outline"></nb-icon>
                Abrir nesta aba
              </button>
              <button class="btn-acao" type="button" (click)="abrirNovaAba($event, aviso)" [disabled]="clienteLinkCarregandoId === aviso.id">
                <nb-icon icon="external-link-outline"></nb-icon>
                Abrir em nova aba
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="chat-aviso-overlay" *ngIf="visivel && mostrarLista" (click)="mostrarLista = false"></div>
